import { fbt } from 'fbtee'
import { Link, Share2 } from 'lucide-react'
import { useAuth } from '../hooks/useAuth'
import { useFriendCode } from '../hooks/useFriendCode'
import { getFriendInviteMessage, getFriendInviteUrl } from '../lib/utils'
import { canNativeShare, copyInviteLink, nativeShareInvite } from '../lib/share'
import { friendInviteQrDescription, friendInviteQrTitle } from '../lib/commonStrings'
import { InviteQrDialog } from './InviteQrDialog'
import { Button } from './ui/button'

/** The one "add a friend" sheet: your QR code plus copy-link and share buttons. */
export function InviteFriendDialog({ open, onOpenChange }: { open: boolean; onOpenChange: (open: boolean) => void }) {
  const { user, signedInUid } = useAuth()
  const { friendCode } = useFriendCode(signedInUid ? user : null)

  return (
    <InviteQrDialog
      open={open}
      onOpenChange={onOpenChange}
      title={friendInviteQrTitle()}
      description={friendInviteQrDescription()}
      value={friendCode ? getFriendInviteUrl(friendCode) : ''}
      displayCode={friendCode ?? undefined}
      footer={
        <div className="flex w-full gap-2 pt-1">
          <Button
            variant="outline"
            className="flex-1"
            disabled={!friendCode}
            onClick={() => friendCode && copyInviteLink(getFriendInviteMessage(friendCode), 'friend_social')}
          >
            <Link className="size-4" />
            {fbt('Copy link', 'Button in the add-a-friend sheet that copies your friend invite link')}
          </Button>
          {canNativeShare() && (
            <Button
              variant="outline"
              className="flex-1"
              disabled={!friendCode}
              onClick={() => friendCode && nativeShareInvite(getFriendInviteMessage(friendCode), 'friend_social')}
            >
              <Share2 className="size-4" />
              {fbt('Share', 'Button in the add-a-friend sheet that opens the share sheet for your invite link')}
            </Button>
          )}
        </div>
      }
    />
  )
}
